import LoadMoreButton from '@atoms/LoadMoreButton/LoadMoreButton';
import { IProductOfferListing } from '@models/IProductOfferListing';
import ProductListingCard from '@molecules/ProductListingCard/ProductListingCard';
import useMediaQuery from '@utils/hooks/useMediaQuery';
import useRefocus from '@utils/hooks/useRefocus';
import { useState } from 'react';

const ProductOfferListing = ({
  title,
  items,
  loadMoreLabel,
  pageSize,
  statusLabels,
  viewedLabel,
  anchorId = '',
}: IProductOfferListing) => {
  const isMobile = useMediaQuery(1024);
  const [displayedItemsCount, setDisplayedItemsCount] = useState(
    Math.min(items.length, pageSize)
  );
  const pageNumber = Math.ceil(displayedItemsCount / pageSize);
  const focusedIndex = (pageNumber - 1) * pageSize;
  const focusPlaceholderRef = useRefocus(displayedItemsCount);

  return (
    <div
      className="component-padding bg-black-100 text-white"
      id={`a-${anchorId}`}
      data-testid="CT-71-Product-Offer-Listing"
    >
      <div className="container">
        {title && (
          <h2
            className={`mb-7.5 lg:mb-15 ${isMobile ? 'h3' : ''}`}
            data-testid="CT-71-Product-Offer-Listing-Title"
          >
            {title}
          </h2>
        )}

        <div className="flex flex-col gap-y-7.5 lg:grid lg:grid-cols-12 lg:gap-x-4 lg:gap-y-[5.625rem]">
          {items.slice(0, displayedItemsCount).map((item, index) => (
            <div
              tabIndex={-1}
              key={item.title}
              className="col-span-4"
              ref={
                focusedIndex > 0 && focusedIndex === index
                  ? focusPlaceholderRef
                  : null
              }
            >
              <ProductListingCard
                dataTestId={`CT-71-Product-Offer-Listing-Card-${index}`}
                {...item}
                statusLabels={statusLabels}
                productListingName={title}
              />
            </div>
          ))}
        </div>

        <div className="mt-7.5 flex flex-col items-start gap-y-5 lg:mt-13 lg:items-center">
          <p>
            {viewedLabel
              .replace('{0}', `${displayedItemsCount}`)
              .replace('{1}', `${items.length}`)}
          </p>

          {displayedItemsCount < items.length && (
            <LoadMoreButton
              dataTestId="CT-71-Product-Offer-Listing-Load-More"
              loadMoreLabel={loadMoreLabel}
              onClick={() => {
                const newDisplayedItemsCount = displayedItemsCount + pageSize;
                setDisplayedItemsCount(
                  newDisplayedItemsCount < items.length
                    ? newDisplayedItemsCount
                    : items.length
                );
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default ProductOfferListing;
